<template>
  <div class="form-verify-contract">
    <validation-observer
ref="formVerifyContractContact"
v-slot="{ invalid }"
>
      <b-form class="repeater-form">
        <div class="contact-info-section">
          <h4 class="title-content">
            {{
              $t(
                "stepGuideControl.stepVerifyInfo.formVerifyContract.titleContactInfo"
              )
            }}
          </h4>
          <p class="subtitle-content">
            {{ $t('stepGuideControl.stepVerifyInfo.formVerifyContract.noteEnsureInfoAccuracy') }}
          </p>

          <!-- <b-form-group class="group-input">
            <div class="d-flex align-items-center">
              <label class="form-label mb-0">
                {{
                  $t(
                    "stepGuideControl.stepVerifyInfo.formVerifyContract.labelUseNewAdministrativeArea"
                  )
                }}
              </label>
              <b-form-checkbox
                :checked="form.useNewAdministrativeArea"
                switch
                class="custom-control-primary ml-2"
                @input="v => $emit('update', { useNewAdministrativeArea: v })"
              />
            </div>
          </b-form-group> -->

          <b-row class="administrative-row">
            <b-col
cols="12"
md="6"
class="pr-md-0"
>
              <b-form-group
                class="group-input"
                data-testid="form-group-province"
              >
                <div class="d-flex justify-content-between">
                  <label
class="form-label"
for="province"
>
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelProvince"
                      )
                    }}
                    <span class="text-danger">*</span>
                  </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  id="province"
                  rules="required"
                  :name="
                    $t(
                      'stepGuideControl.stepVerifyInfo.formVerifyContract.nameProvince'
                    )
                  "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <v-select
                      :value="form.province"
                      style="width: 100%"
                      :placeholder="
                        $t(
                          'stepGuideControl.stepVerifyInfo.formVerifyContract.placeholderProvince'
                        )
                      "
                      class="input-height"
                      :disabled="hasDisabled"
                      :options="options.province"
                      @input="v => $emit('update', { province: v })"
                    >
                      <template #open-indicator="{ attributes }">
                        <span
v-bind="attributes"
><feather-icon
icon="ChevronDownIcon"
size="20"
/></span>
                      </template>
                      <template #no-options>
                        {{ $t('stepGuideControl.stepVerifyInfo.formVerifyContract.textNoOptions') }}
                      </template>
                    </v-select>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
v-if="!form.useNewAdministrativeArea"
cols="12"
md="6"
>
              <b-form-group
                class="group-input"
                data-testid="form-group-district"
              >
                <div class="d-flex justify-content-between">
                  <label
class="form-label"
for="district"
>
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelDistrict"
                      )
                    }}
                  </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  id="district"
                  :name="
                    $t(
                      'stepGuideControl.stepVerifyInfo.formVerifyContract.nameDistrict'
                    )
                  "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <v-select
                      :value="form.district"
                      style="width: 100%"
                      :placeholder="
                        $t(
                          'stepGuideControl.stepVerifyInfo.formVerifyContract.placeholderDistrict'
                        )
                      "
                      class="input-height"
                      :disabled="hasDisabled || !form.province"
                      :options="options.district"
                      @input="v => $emit('update', { district: v })"
                    >
                      <template #open-indicator="{ attributes }">
                        <span
v-bind="attributes"
><feather-icon
icon="ChevronDownIcon"
size="20"
/></span>
                      </template>
                      <template #no-options>
                        {{ $t('stepGuideControl.stepVerifyInfo.formVerifyContract.textNoOptions') }}
                      </template>
                    </v-select>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
v-else
cols="12"
md="6"
>
              <b-form-group
class="group-input"
data-testid="form-group-ward"
>
                <div class="d-flex justify-content-between">
                  <label
class="form-label"
for="ward"
>
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelWard"
                      )
                    }}
                    <span class="text-danger">*</span>
                  </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  id="ward"
                  rules="required"
                  :name="
                    $t(
                      'stepGuideControl.stepVerifyInfo.formVerifyContract.nameWard'
                    )
                  "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <v-select
                      :value="form.ward"
                      style="width: 100%"
                      :placeholder="
                        $t(
                          'stepGuideControl.stepVerifyInfo.formVerifyContract.placeholderWard'
                        )
                      "
                      class="input-height"
                      :disabled="hasDisabled || !form.province"
                      :options="options.ward"
                      @input="v => $emit('update', { ward: v })"
                    >
                      <template #open-indicator="{ attributes }">
                        <span
v-bind="attributes"
><feather-icon
icon="ChevronDownIcon"
size="20"
/></span>
                      </template>
                      <template #no-options>
                        {{ $t('stepGuideControl.stepVerifyInfo.formVerifyContract.textNoOptions') }}
                      </template>
                    </v-select>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="!form.useNewAdministrativeArea">
            <b-col
cols="12"
md="6"
class="pr-md-0"
>
              <b-form-group
class="group-input"
data-testid="form-group-ward"
>
                <div class="d-flex justify-content-between">
                  <label
class="form-label"
for="ward"
>
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelWard"
                      )
                    }}
                    <span class="text-danger">*</span>
                  </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  id="ward"
                  rules="required"
                  :name="
                    $t(
                      'stepGuideControl.stepVerifyInfo.formVerifyContract.nameWard'
                    )
                  "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <v-select
                      :value="form.ward"
                      style="width: 100%"
                      :placeholder="
                        $t(
                          'stepGuideControl.stepVerifyInfo.formVerifyContract.placeholderWard'
                        )
                      "
                      class="input-height"
                      :disabled="
                        hasDisabled || !form.province || !form.district
                      "
                      :options="options.ward"
                      @input="v => $emit('update', { ward: v })"
                    >
                      <template #open-indicator="{ attributes }">
                        <span
v-bind="attributes"
><feather-icon
icon="ChevronDownIcon"
size="20"
/></span>
                      </template>
                      <template #no-options>
                        {{ $t('stepGuideControl.stepVerifyInfo.formVerifyContract.textNoOptions') }}
                      </template>
                    </v-select>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
cols="12"
md="6"
>
              <b-form-group
                class="group-input"
                data-testid="form-group-address"
              >
                <div class="d-flex justify-content-between">
                  <label
class="form-label"
for="address"
>
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelAddress"
                      )
                    }}
                    <span class="text-danger">*</span>
                  </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  id="address"
                  rules="required|max:200"
                  :name="
                    $t(
                      'stepGuideControl.stepVerifyInfo.formVerifyContract.nameAddress'
                    )
                  "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="verify-address"
                      :value="form.address"
                      data-testid="verify-address"
                      class="input-height"
                      :placeholder="
                        $t(
                          'stepGuideControl.stepVerifyInfo.formVerifyContract.placeholderAddress'
                        )
                      "
                      :disabled="hasDisabled"
                      :state="errors.length > 0 ? false : null"
                      @input="v => updateField('address', v)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-else>
            <b-col cols="12">
              <b-form-group
                class="group-input"
                data-testid="form-group-address"
              >
                <div class="d-flex justify-content-between">
                  <label
                    class="form-label"
                    for="address"
                  >
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelAddress"
                      )
                    }}
                    <span class="text-danger">*</span>
                  </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  id="address"
                  rules="required|max:200"
                  :name="
                    $t(
                      'stepGuideControl.stepVerifyInfo.formVerifyContract.nameAddress'
                    )
                  "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="verify-address"
                      :value="form.address"
                      data-testid="verify-address"
                      class="input-height"
                      :placeholder="
                        $t(
                          'stepGuideControl.stepVerifyInfo.formVerifyContract.placeholderAddress'
                        )
                      "
                      :disabled="hasDisabled"
                      :state="errors.length > 0 ? false : null"
                      @input="v => updateField('address', v)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              md="6"
              class="pr-md-0"
            >
              <b-form-group
                class="group-input"
                data-testid="form-group-contact-email"
              >
                <div class="d-flex justify-content-between">
                  <label
                    class="form-label"
                    for="contactEmail"
                  >
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelContactEmail"
                      )
                    }}
                    <span class="text-danger">*</span>
                  </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  id="contactEmail"
                  rules="required|email|max:100"
                  :name="
                    $t(
                      'stepGuideControl.stepVerifyInfo.formVerifyContract.nameContactEmail'
                    )
                  "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="verify-contact-email"
                      :value="form.contactEmail"
                      data-testid="verify-contact-email"
                      type="email"
                      class="input-height"
                      :placeholder="
                        $t(
                          'stepGuideControl.stepVerifyInfo.formVerifyContract.placeholderContactEmail'
                        )
                      "
                      :disabled="hasDisabled"
                      :state="errors.length > 0 ? false : null"
                      @input="v => updateField('contactEmail', v)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                rules="required|min:10|max:20"
                :name="
                  $t(
                    'stepGuideControl.stepVerifyInfo.formVerifyContract.nameContactPhone'
                  )
                "
              >
                <div class="phone-validation-wrapper">
                  <input
                    :value="form.phoneData.phone"
                    type="text"
                    class="d-none"
                    aria-hidden="true"
                    tabindex="-1"
                  >
                  <b-form-group
                    class="group-input"
                    :class="{ 'phone-number-error': errors.length > 0 }"
                  >
                    <phone-input
                      :class="hasDisabled ? 'bg-input-disable' : ''"
                      :phone-data="form.phoneData"
                      :disabled="hasDisabled"
                      :is-error-phone-number="isErrorPhoneNumber || errors.length > 0"
                      :disable-country-select="true"
                      :min-length="10"
                      @update:phone-data="updatePhoneData"
                    />
                  </b-form-group>
                </div>
              </validation-provider>
            </b-col>
          </b-row>

        </div>

        <div class="btn-control btn-control--group">
          <b-button
            class="btn-back-inline"
            variant="link"
            :disabled="loading"
            @click="$emit('back')"
          >
          <div class="d-flex align-content-center">

            <feather-icon
              icon="ChevronLeftIcon"
              size="16"
            />
            {{
              $t("stepGuideControl.stepVerifyInfo.formVerifyContract.textBack")
            }}
          </div>
          </b-button>
          <btn-loading
            id="btn-submit-verify-contract"
            data-testid="btn-submit-verify-contract"
            type="submit"
            variant-convert="btn-submit"
            pill
            :loading="loading"
            @click.prevent="$emit('submit', invalid)"
          >
          <div class="d-flex align-content-center">
            {{
              $t(
                "stepGuideControl.stepVerifyInfo.formVerifyContract.textSubmitAndContinue"
              )
            }}
            <feather-icon
              icon="ChevronRightIcon"
              size="16"
            />
          </div>
          </btn-loading>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BFormGroup,
  BForm,
  BFormInput,
  BInputGroup,
  BRow,
  BCol,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import vSelect from 'vue-select'
import PhoneInput from '@/views/auth/PhoneInput.vue'
import { trimValue } from '@/@core/utils/utils'

export default {
  name: 'ContractInfoVerificationStep3',

  components: {
    BButton,
    BFormGroup,
    BForm,
    BFormInput,
    BInputGroup,
    BRow,
    BCol,
    BtnLoading,
    vSelect,
    PhoneInput,
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    form: { type: Object, required: true },
    options: { type: Object, required: true },
    hasDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      isErrorPhoneNumber: false,
    }
  },

  methods: {
    validate() {
      return this.$refs.formVerifyContractContact.validate()
    },
    reset() {
      return this.$refs.formVerifyContractContact.reset()
    },
    updateField(field, value) {
      this.$emit('update', { [field]: trimValue(value) })
    },
    updatePhoneData(phoneData) {
      this.$emit('update', { phoneData: { ...phoneData, phone: trimValue(phoneData?.phone) } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";

$font-size-section: 18px;
$font-size-body: 14px;

.input-height {
  height: 48px;
}

.contact-info-section {
  margin-top: 0;
  padding-top: 0;
  border-top: none;

  .title-content {
    font-size: 18px;
    font-weight: 600;
    color: #16213e;
    margin: 0 0 8px 0;
    line-height: 1.4;
  }

  .subtitle-content {
    font-size: 14px;
    line-height: 1.5;
    color: #6b7280;
    margin: 0 0 24px 0;
  }

  .switch-label {
    margin-left: 8px;
    font-size: $font-size-body;
    font-weight: 500;
    color: #16213e;
  }
}

.btn-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  &--group {
    justify-content: flex-end;
    gap: 8px;
  }
}

.bg-input-disable {
  .int-tel-input {
    background-color: #efefef;
    color: #16213e;
  }
}

.phone-number-error {
  .int-tel-input {
    input {
      border: 1px solid #e11c4e;
    }
  }
}
</style>
